<img [src]="resource" [alt]="alt" (load)="revokeurl()" (error)="onError()">
